import './App.css';
import {useEffect, useState} from "react";
import RouteRAF from "./layouts/RouteRAF";
import ToponomasticaService from "./services/ToponomasticaService";
import globals from "./config/appconfig";
import Spinner from "./components/spinner/Spinner";

function App() {

    const [app,setApp] = useState(<div><Spinner show={true}/></div>)
    const urlSpamobile = globals["url-spa-mobile"]
    const [showSpinner, setShowSpinner] = useState(false)
    useEffect( () => {
        require("bootstrap-italia/dist/js/bootstrap-italia.min");
        require("bootstrap-italia/dist/css/bootstrap-italia.min.css");
        const isMobile = window.innerWidth < 1024 && window.innerHeight < 1366;
        if(isMobile && window.location.pathname.toLowerCase() !== "/wizardregistro" &&
            window.location.pathname.toLowerCase() !== "/registro" &&
            window.location.pathname.toLowerCase() !== "/sportelli" &&
            window.location.pathname.toLowerCase() !== "/utenti"&&
            window.location.pathname.toLowerCase() !== "/report"){
            window.location.replace(urlSpamobile);
        }
        if (!sessionStorage.getItem("toponomasticaCaricataCorrettamente") ||
            sessionStorage.getItem("toponomasticaCaricataCorrettamente") !== "true") {
            sessionStorage.setItem("sessioneUtente",JSON.stringify({tipoUtente: "03",loggedIn:false}))

            setShowSpinner(true)
            ToponomasticaService({renderApp:renderApp, setShowSpinner:setShowSpinner})
        }else{
            renderApp()
        }
    },[])

    function renderApp(){
        setApp(
            <div className="container-raf" style={{minWidth: "768px", maxWidth: "1440px"}}>
                <Spinner show={showSpinner}/>
                <RouteRAF/>
            </div>
        )
    }

    return (app);
}

export default App;
